import React, { type ReactNode } from 'react';

import type { RulesExtend } from '@ackee/fela';
import { useFelaEnhanced } from '@ackee/fela';
import { Button, ButtonSize } from '../../../../ui';

import * as felaRules from './PageLink.rules';

export interface PageLinkProps {
    basePath: string;
    page: number;
    label?: ReactNode;
    extend?: RulesExtend<typeof felaRules>;
}

export const PageLink = ({ basePath, page, label = page, extend }: PageLinkProps) => {
    const { rules } = useFelaEnhanced(felaRules, { extend });

    return (
        <Button
            type={Button.Type.LINK}
            size={ButtonSize.SMALL}
            extend={{ button: rules.button }}
            to={page === 1 ? basePath : `${basePath}/${page}`}
        >
            {label}
        </Button>
    );
};
